var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-square_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 55C18.2149 55 12.3223 55 8.66117 51.3387C5 47.6777 5 41.785 5 30C5 18.2149 5 12.3223 8.66117 8.66117C12.3223 5 18.2149 5 30 5C41.785 5 47.6777 5 51.3387 8.66117C55 12.3223 55 18.2149 55 30C55 41.785 55 47.6777 51.3387 51.3387C47.6777 55 41.785 55 30 55ZM30 20.625C31.0355 20.625 31.875 21.4645 31.875 22.5V28.125H37.5C38.5355 28.125 39.375 28.9645 39.375 30C39.375 31.0355 38.5355 31.875 37.5 31.875H31.875V37.5C31.875 38.5355 31.0355 39.375 30 39.375C28.9645 39.375 28.125 38.5355 28.125 37.5V31.875H22.5C21.4645 31.875 20.625 31.0355 20.625 30C20.625 28.9645 21.4645 28.125 22.5 28.125H28.125V22.5C28.125 21.4645 28.9645 20.625 30 20.625Z",
    fill: "#334155"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProject);
export default __webpack_public_path__ + "static/media/add-project.91332c63590e4f0c0a59bcabb9c40fc6.svg";
export { ForwardRef as ReactComponent };